import PendienteService from 'src/modules/pendiente/pendienteService';
import Errors from 'src/modules/shared/error/errors';
import { getHistory } from 'src/modules/history';

const prefix = 'PENDIENTE_VIEW';

const pendienteViewActions = {
  FIND_STARTED: `${prefix}_FIND_STARTED`,
  FIND_SUCCESS: `${prefix}_FIND_SUCCESS`,
  FIND_ERROR: `${prefix}_FIND_ERROR`,

  doFind: (id) => async (dispatch) => {
    try {
      dispatch({
        type: pendienteViewActions.FIND_STARTED,
      });

      const record = await PendienteService.find(id);

      dispatch({
        type: pendienteViewActions.FIND_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: pendienteViewActions.FIND_ERROR,
      });

      getHistory().push('/pendiente');
    }
  },
};

export default pendienteViewActions;
